export const TEST_ID = 'recenterMapButton';
